export const PAYMENT_METHOD = {
  CREDIT_CARD: 'CREDIT_CARD',
  CASH: 'CASH',
  GIFT_CARD: 'GIFT_CARD',
  RETROSPECTIVE_DISCOUNT: 'RETROSPECTIVE_DISCOUNT',
  MANUAL_REFUND: 'MANUAL_REFUND',
  PAYMENT_LINK: 'PAYMENT_LINK',
  PAY_AT_PICKUP: 'PAY_AT_PICKUP',
  TO_TERMINAL: 'TO_TERMINAL',
  MANUAL_CREDIT_CARD_PAYMENT: 'MANUAL_CREDIT_CARD_PAYMENT',
  MANUAL_CREDIT_CARD_REFUND: 'MANUAL_CREDIT_CARD_REFUND'
}

export const PAYMENT_TYPE = {
  CASH: 'cash-payment',
  PAY_AT_PICKUP: 'pay-at-pickup',
  SEND_PAYMENT_LINK: 'send-payment-link',
  CITY_VOUCHER: 'city-voucher',
  TERMINAL: 'terminal',
  ADMIN_PAYMENT: 'admin-payment', // This is used for admin payments - same logic as pay-at-pickup
  RETROSPECTIVE_DISCOUNT: 'retrospective-discount',
  GIFT_CARD: 'gift-card',
  MANUAL_PAYMENT: 'manual-payment'
}

export const REFUND_TYPE = {
  MANUAL: 'manual-refund',
  GIFT_CARD: 'gift-card-refund',
  TERMINAL: 'terminal-refund',
  ADYEN_API: 'adyen-api-refund',
  CREDIT_CARD_REFUND: 'credit-card-refund' // Terminal prints receipt, refunds to original credit card (no card presentation)
}

export const CURRENCY_CODE = {
  EUR: 'EUR',
  CHF: 'CHF'
}

export const CURRENCY_SYMBOL = {
  EUR: '€',
  CHF: 'CHF'
}

// wings-payment-source-token is used as a dummy token
// as we don't need payment source token, but it's required by the commerce layer
export const PAYMENT_SOURCE_TOKEN = 'wings-payment-source-token'

export const DISCOUNT_TYPES = [
  'percentage_discount_promotions',
  'fixed_amount_promotions',
  'external_promotions',
  'flex_promotions'
]
